export default "__VITE_ASSET__TSQV$Qxb__"